export function CustomDashboardSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/custom-dashboard.svg'"></ng-include>`
    }
}